<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$router.replace('/NewMainPage');
  }
};
</script>

<style></style>
